import { merchantApi } from '@/config/axios'

export interface BrandVO {
  id?: number
  name: string
  picUrl?: string
  sort?: number
  status?: number
}

/** 商家端：平台开启的品牌精简列表 */
export const getSimpleBrandList = async () => {
  return await merchantApi.get<BrandVO[]>({
    url: '/merchant-api/product/brand/list-all-simple'
  })
}
